module.exports = __webpack_public_path__ + "static/media/13_gallery.bc34af11.png";